import BehaviourTooltipView from './BehaviourTooltipView'

export default BehaviourTooltipView
